module.exports = __webpack_public_path__ + "static/media/TKEStackConsole-2048x821.1eb3ac69.png";